var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h2',[_vm._v("Verification")]),_c('p',[_vm._v(" You should be logged in automatically when your verification is successfull. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }